/*
 * app-config.ts
 * utms-admin-dashboard
 * 
 * Created by Tetiana Makovii on 14.04.2022
 * Copyright © 2026 Sonova AG. All rights reserved.
 */




import { MsalGuardConfiguration, MsalInterceptorConfiguration } from "@azure/msal-angular";
import { BrowserCacheLocation, Configuration, InteractionType, LogLevel } from "@azure/msal-browser";
import { environment } from "src/environments/environment";

export const msalConfig: Configuration = {
    auth: {
      clientId: environment.clientId,
      authority: `https://login.microsoftonline.com/${environment.tenantName}/`,
      redirectUri: environment.redirectUrl
    },
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage,
      storeAuthStateInCookie: false, // set to true for IE 11
    },
    system: {
      loggerOptions: {
        loggerCallback,
        logLevel: LogLevel.Info,
        piiLoggingEnabled: false
      }
    }
  }

export function loggerCallback(logLevel: LogLevel, message: string)
{
    console.log(message);
}



const protectedResourceMap = new Map<string, Array<string>>()
protectedResourceMap.set(`${environment.apiUrl}`, [`${environment.clientId}/.default`]);

export const msalInterceptorConfig: MsalInterceptorConfiguration = {
    interactionType: InteractionType.Redirect,
    protectedResourceMap
};

export const msalGuardConfig: MsalGuardConfiguration = {
    interactionType: InteractionType.Redirect,
    authRequest: {
      scopes: [`${environment.clientId}/.default`]
    },
  };